import {type OmitStrict} from 'type-zoo'
import {DatoImage, type DatoImageProps} from '~/cms/components/DatoImage'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {type PartialPartial} from '~/utils/types'
import {type ArticleListingFragment} from './_generated/fragment.graphql'

export const getArticleListingProps = (
  articleListing: PartialPartial<
    Pick<
      ArticleListingFragment,
      'topic' | 'slug' | 'articleTitle' | 'subheading' | 'authors' | 'previewImage'
    >,
    'previewImage'
  >,
  datoImageProps?: OmitStrict<DatoImageProps, 'data'>
) => {
  return {
    topic: {
      slug: articleListing?.topic?.slug || '',
      name: articleListing?.topic?.name || 'Invalid topic',
    },
    slug: articleListing?.slug || '',
    title: articleListing?.articleTitle || 'Invalid article',
    subheading: articleListing
      ? articleListing.subheading && (
          <SingleLineStructuredText data={articleListing.subheading} />
        )
      : 'Please ensure that you are correctly populating the article listings. You may need to manually add them or double check that your selected filters have a sufficient number of articles.',
    authors: articleListing?.authors || [],
    image: articleListing?.previewImage && (
      <DatoImage data={{image: articleListing.previewImage}} {...datoImageProps} />
    ),
  }
}
